export const LARK_NOTIFICATION_TYPES = [
  { key: "cash_out_request", label: "Cash out request" },
  { key: "complaint_created", label: "New complaint" },
  { key: "post_report_created", label: "New post report" },
  { key: "user_report_created", label: "New user report" },
];
